import { createStoreWithPersistent } from "@core/hooks/useStore";
import { requestAlegriia } from "@utils/requests";
import { StateCreator } from "zustand";

type Topic = "restaurant" | "client" | undefined;
interface IStore {
  notificationToken?: string | null; //Is for FCM Token
  idAddress?: string | undefined;
  topics?: Topic[];
  setTopics?: (topics: Topic[]) => void;
  setNotificationToken?: (notificationToken: string) => void;
  unsubscribeTopics?: () => Promise<void>;
  setAddress?: (idAddress: string | undefined) => void;
}

const store: StateCreator<IStore> = (set, get) => ({
  notificationToken: "",
  idAddress: "",
  topics: undefined,
  setTopics: (topics: Topic[]) => set(() => ({ topics })),
  setNotificationToken: (notificationToken) =>
    set(() => ({ notificationToken })),
  setAddress: (idAddress) => set(() => ({ idAddress })),
  unsubscribeTopics: async () => {
    try {
      const tokenFCM = get().notificationToken;
      if (!tokenFCM) return;
      await requestAlegriia.post(
        "/notifications/unsubscribe",
        { topics: get().topics, tokenFCM },
        {
          withCredentials: true,
        },
      );
      set(() => ({ notificationToken: null, topics: [] }));
    } catch (err) {
      console.log("Error al unsubscribe topics", err);
    } finally {
      set({ topics: [] });
    }
  },
});

export const useStore = createStoreWithPersistent<IStore>({
  initialState: store,
  nameStorage: "general",
  storage: "session",
});
